import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapProcessingReviewDataFromServer } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse, ProcessingReviewDto } from "types";

type useGetProcessingReviewByCreditReviewIdQueryProps = {
	creditReviewId: string;
	isEnabled: boolean;
};

const useGetProcessingReviewByCreditReviewIdQuery = ({
	creditReviewId,
	isEnabled,
}: useGetProcessingReviewByCreditReviewIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["processingReviewData", creditReviewId],
		() =>
			creditReviewDetailsService.getProcessingReview({
				creditReviewId,
			}),
		{
			select: (data: ProcessingReviewDto) => {
				return mapProcessingReviewDataFromServer(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId && isEnabled,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetProcessingReviewByCreditReviewIdQuery;
